var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPaginationNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 10.8333L14.3083 10.8333L11.325 13.825L12.5 15L17.5 10L12.5 5L11.325 6.18333L14.3083 9.16667L2.5 9.16667L2.5 10.8333Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationNext);
export default __webpack_public_path__ + "static/media/pagination-next.f7f9d97e.svg";
export { ForwardRef as ReactComponent };